// Exact-string number display: no Number()/float conversion, so server numerics show exactly as given.

export function groupInteger(intStr, sepChar) {
  if (!sepChar) return intStr;
  const result = [];
  for (let i = intStr.length - 1, count = 0; i >= 0; i--, count++) {
    if (count > 0 && count % 3 === 0) result.unshift(sepChar);
    result.unshift(intStr[i]);
  }
  return result.join('');
}

const DECIMAL = /^(-?)(\d+)(?:\.(\d*))?$/;

// '1234.50' -> '1234.5', '25.00' -> '25', '-0.00' -> '0', '007' -> '7'. Non-numeric text is returned as is.
export function trimDecimal(value) {
  if (value == null || value === '') return null;
  const m = String(value).trim().match(DECIMAL);
  if (!m) return String(value);
  const int = m[2].replace(/^0+(?=\d)/, '');
  const frac = (m[3] || '').replace(/0+$/, '');
  const sign = /[1-9]/.test(int + frac) ? m[1] : '';
  return `${sign}${int}${frac ? `.${frac}` : ''}`;
}

// Trimmed, grouped with `sep`, decimal mark `dec`, padded to `minFrac` decimals. null/'' -> '—'.
export function formatExactDecimal(value, sep, dec, minFrac = 0) {
  const trimmed = trimDecimal(value);
  if (trimmed == null) return '—';
  const m = trimmed.match(DECIMAL);
  if (!m) return trimmed;
  const frac = (m[3] || '').padEnd(minFrac, '0');
  return `${m[1]}${groupInteger(m[2], sep)}${frac ? `${dec}${frac}` : ''}`;
}

// Exact comparison of decimal strings (sign, integer length, then digits). Non-decimals fall back to text.
export function compareDecimal(left, right) {
  const a = trimDecimal(left); const b = trimDecimal(right);
  const ma = String(a).match(DECIMAL); const mb = String(b).match(DECIMAL);
  if (!ma || !mb) return String(a).localeCompare(String(b), undefined, { numeric: true });
  if (ma[1] !== mb[1]) return ma[1] ? -1 : 1;
  const width = Math.max((ma[3] || '').length, (mb[3] || '').length);
  const digits = m => `${m[2]}${(m[3] || '').padEnd(width, '0')}`;
  const av = digits(ma); const bv = digits(mb);
  const result = av.length === bv.length ? (av < bv ? -1 : av > bv ? 1 : 0) : av.length - bv.length;
  return ma[1] ? -result : result;
}
